import React from 'react';
import Picture from "../media/picture";

export default class ImageModal extends React.Component {

    constructor(props) {
        super(props);

        this.events = {
            open: 'modal.image.open.'+props.id,
            //close: 'modal.image.close.'+props.id,
            //toggle: 'modal.image.toggle.'+props.id,
        }

        this.state = {
            open: false
        }

        this.EventManager = window.app.eventManager;
        this.EventManager.createEvent(this.events.open, 'Used to open image modal for '+props.id, 'This event is triggered when you want to open the relevant youtube modal', this);
        //this.EventManager.createEvent(this.events.close, 'Used to close image modal for '+props.id, 'This event is triggered when you want to close the relevant youtube modal', this);
        //this.EventManager.createEvent(this.events.toggle, 'Used to toggle image modal for '+props.id, 'This event is triggered when you want to close/open the relevant youtube modal', this);
    }

    componentDidMount() {
        this.EventManager.subscribe(this.events.open, (e) => {
            this.toggle(true);
        });
        /*this.EventManager.subscribe(this.events.close, (e) => {
            this.toggle(false);
        });
        this.EventManager.subscribe(this.events.toggle, (e) => {
            this.toggle();
        });*/
    }

    toggle = (open = null) => {
        open = (open !== null) ? open : !this.state.open;
        this.setState({open: open});
    }

    render() {
        let classname = 'modal-shroud' + (this.state.open ? '' : 'hidden');
        if(!this.state.open) return <></>;

        return (
            <div className={classname}  onClick={ () => { this.toggle(false) }}>
                <div className="modal">
                    <Picture filter="cabin_image_large" src={this.props.src} />
                    <button className="modal-close" onClick={ () => { this.toggle(false) }}>×</button>
                </div>
            </div>
        )
    }
};
